// import { AppStatic } from '../_helpers/app-static'

import { BaseClass } from './_base.model'

export interface SettingData {
  value: any
}

export class Setting extends BaseClass {
  klass = 'Setting'

  name: string
  data: SettingData

  get value() {
    return this.data.value
  }
}
